require('../../modules/es7.regexp.escape');
module.exports = require('../../modules/$.core').RegExp.escape;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/regexp/escape.js
// module id = 288
// module chunks = 0